import { memo } from "react";

import { useAppTheme } from "../../useAppTheme";
import { useDevice } from "../../useDevice";
import Box, { type BoxProps } from "../Box";

export const PostAnswerCard = memo(({ children, ...props }: BoxProps) => {
	const theme = useAppTheme();
	const { isMobile } = useDevice();

	return (
		<Box
			borderWidth={isMobile ? 0 : 1}
			paddingHorizontal={16}
			paddingVertical={isMobile ? 8 : 16}
			borderColor={theme.colors.outlineVariant}
			borderRadius={theme.roundness * 2}
			gap={16}
			{...props}
		>
			{children}
		</Box>
	);
});
